import { ScannerError } from '../utils/errors.js';
import { buildAdaptiveVideoConstraints } from './adaptive-profile.js';

export function stopStream(stream) {
    stream?.getTracks?.().forEach((track) => track.stop());
}

export function waitForVideo(video, timeoutMs = 5000) {
    if (video.readyState >= 1) {
        return Promise.resolve({
            event: 'readyState',
            readyState: video.readyState,
        });
    }

    return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
            cleanup();
            reject(new ScannerError(
                'CAMERA_PREVIEW_TIMEOUT',
                'A câmera abriu, mas o vídeo não ficou pronto dentro do tempo esperado.',
                { recoverable: true, context: 'camera' }
            ));
        }, timeoutMs);

        const onReady = (event) => {
            cleanup();
            resolve({
                event: event.type,
                readyState: video.readyState,
            });
        };
        const onError = () => {
            cleanup();
            reject(new ScannerError(
                'CAMERA_PREVIEW_ERROR',
                'A câmera abriu, mas o navegador não conseguiu exibir o vídeo.',
                { recoverable: true, context: 'camera' }
            ));
        };
        const cleanup = () => {
            clearTimeout(timeout);
            video.removeEventListener('loadedmetadata', onReady);
            video.removeEventListener('canplay', onReady);
            video.removeEventListener('error', onError);
        };

        video.addEventListener('loadedmetadata', onReady, { once: true });
        video.addEventListener('canplay', onReady, { once: true });
        video.addEventListener('error', onError, { once: true });
    });
}

export function buildConstraintAttempts(deviceId, profile) {
    const attempts = [];

    if (deviceId) {
        attempts.push({
            label: 'dispositivo selecionado com perfil adaptativo',
            constraints: {
                audio: false,
                video: buildAdaptiveVideoConstraints({
                    profile,
                    deviceId,
                }),
            },
        });
        attempts.push({
            label: 'dispositivo selecionado com configuração básica',
            constraints: {
                audio: false,
                video: { deviceId: { exact: deviceId } },
            },
        });
    }

    attempts.push({
        label: 'câmera traseira com perfil adaptativo',
        constraints: {
            audio: false,
            video: buildAdaptiveVideoConstraints({
                profile,
                facingMode: 'environment',
            }),
        },
    });
    attempts.push({
        label: 'qualquer câmera disponível',
        constraints: { audio: false, video: true },
    });

    return attempts;
}
